import { MeSchema, UserSchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { meKeys } from './keys';

export function useUpdateMe() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (user: Partial<UserSchema>) =>
      apiClient.patch<ApiResponse<MeSchema>>('/v1/me', user),
    onSuccess: (response) => {
      if (!response?.data) return;
      queryClient.setQueryData(meKeys.all, { ...response.data, policies: response.policies ?? [] });
    },
  });
}
